(function () {
  function setup(dialog) {
    if (dialog.dataset.venueInitialized) return;
    dialog.dataset.venueInitialized = 'true';
    const section = dialog.closest('[data-private-events-section]');
    const contexts = JSON.parse(section.querySelector('[data-venue-booking-config]').textContent);
    const form = dialog.querySelector('[data-booking-form]');
    const steps = Array.from(dialog.querySelectorAll('[data-booking-step]'));
    const intros = Array.from(dialog.querySelectorAll('[data-booking-intro]'));
    const next = dialog.querySelector('[data-booking-next]');
    const back = dialog.querySelector('[data-booking-back]');
    const error = dialog.querySelector('[data-booking-error]');
    const retry = dialog.querySelector('[data-venue-retry]');
    const loading = dialog.querySelector('[data-venue-loading]');
    const verification = dialog.querySelector('[data-venue-verification]');
    const actions = dialog.querySelector('[data-booking-actions]');
    const success = dialog.querySelector('[data-booking-success]');
    const successActions = dialog.querySelector('[data-booking-success-actions]');
    const stepLabel = dialog.querySelector('[data-booking-step-label]');
    const providerHost = dialog.querySelector('[data-venue-provider-host]');
    const optInLabel = form.elements.email_opt_in.closest('label');
    const referralLabel = form.elements.referral_source_id.closest('label');
    const referralOther = dialog.querySelector('[data-booking-referral-other]');
    let step = 1;
    let context;
    let trigger;
    let adapter;
    let generation = 0;
    let hasCaptcha = false;
    let sending = false;
    let locked = false;
    const labels = ['Next: Your Event', 'Next: Event Details', 'Next: Additional Details', 'Review Request', 'Submit Request'];
    const values = () => Object.fromEntries(new FormData(form).entries());
    function updateReferralOther() {
      const other = !form.elements.referral_source_id.disabled && form.elements.referral_source_id.selectedOptions[0]?.text.toLowerCase() === 'other';
      referralOther.hidden = !other; form.elements.referral_source_other.disabled = !other;
    }
    function setError(message) { error.textContent = message || ''; error.hidden = !message; }
    function renderSummary() {
      const data = values();
      const rows = [
        ['Venue', context?.label, 0], ['Contact', [data.first_name, data.last_name, data.email_address, data.phone_number].filter(Boolean).join(' · '), 1],
        ['Event Style', 'On-Premise Event', 2], ['Event Type', data.event_description, 3],
        ['Date & Time', [data.event_date, data.start_time, data.end_time].filter(Boolean).join(' · '), 3],
        ['Guests', data.guest_count, 3], ['Additional Details', data.additional_information, 4]
      ];
      if (data.company) rows.splice(2, 0, ['Company', data.company, 1]);
      if (data.phone_number_extension) rows.splice(2, 0, ['Phone extension', data.phone_number_extension, 1]);
      if (data.referral_source_id) rows.push(['Referral source', [form.elements.referral_source_id.selectedOptions[0]?.text, data.referral_source_other].filter(Boolean).join(' · '), 4]);
      const review = dialog.querySelector('[data-booking-review]');
      review.replaceChildren();
      rows.forEach(([label, value, editStep]) => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const detail = document.createElement('dd');
        const text = document.createElement('span');
        term.textContent = label; text.textContent = value || '—'; detail.append(text);
        if (editStep) {
          const button = document.createElement('button'); button.type = 'button'; button.textContent = 'Edit';
          button.dataset.bookingEdit = editStep; button.setAttribute('aria-label', `Edit ${label}`); detail.append(button);
        }
        row.append(term, detail); review.append(row);
      });
      dialog.querySelector('[data-booking-mini-summary]').textContent = `${context?.label || ''} · ${data.guest_count || '—'} guests · ${data.event_date || 'Date to come'}`;
    }
    function updateActions() {
      next.textContent = sending ? 'Submitting…' : labels[step - 1];
      next.disabled = locked || sending || (step === 5 && !adapter?.ready);
      back.disabled = sending || locked;
      dialog.querySelectorAll('[data-booking-edit]').forEach((button) => { button.disabled = sending || locked; });
    }
    function showStep(number, focus = true) {
      step = number;
      steps.forEach((item, index) => { item.hidden = index !== step - 1; item.classList.toggle('is-active', index === step - 1); });
      intros.forEach((item, index) => item.classList.toggle('is-active', index === step - 1));
      stepLabel.textContent = `STEP ${step} OF 5`;
      back.hidden = step === 1;
      verification.hidden = !hasCaptcha;
      renderSummary(); updateActions();
      if (focus) {
        const target = steps[step - 1].querySelector('input:not([type="hidden"]), textarea, select, h2');
        if (target?.tagName === 'H2') target.tabIndex = -1;
        target?.focus();
      }
    }
    function providerError(message, details = {}) {
      sending = false;
      locked = Boolean(details.uncertain);
      retry.hidden = !details.retryable;
      loading.hidden = true;
      if (details.fields) {
        const keys = Object.keys(details.fields).join(' ').toLowerCase();
        showStep(/first|last|email|phone|company/.test(keys) ? 1 : /date|time|guest|people|description|event/.test(keys) ? 3 : /captcha|robot/.test(keys) ? 5 : 4);
      }
      setError(message); updateActions();
    }
    function loadProvider() {
      const current = ++generation;
      adapter?.destroy(); adapter = null;
      hasCaptcha = false; verification.hidden = true;
      loading.hidden = false; retry.hidden = true; setError('');
      optInLabel.hidden = true; form.elements.email_opt_in.disabled = true;
      referralLabel.hidden = true; form.elements.referral_source_id.disabled = true;
      referralOther.hidden = true; form.elements.referral_source_other.disabled = true;
      const create = window.CateringVenueProvider?.create;
      if (!create) { providerError('The venue booking service could not load. Please reload the page.'); return; }
      adapter = create({
        host: providerHost, baseUrl: dialog.dataset.providerScript, context,
        onReady(capabilities) {
          if (current !== generation || !dialog.open) return;
          loading.hidden = true; hasCaptcha = capabilities.hasCaptcha; verification.hidden = !hasCaptcha;
          optInLabel.hidden = !capabilities.hasOptIn; form.elements.email_opt_in.disabled = !capabilities.hasOptIn;
          const referral = form.elements.referral_source_id;
          const previous = referral.value;
          referral.replaceChildren(...capabilities.referrals.map((item) => { const option = new Option(item.label, item.value); option.disabled = item.disabled; return option; }));
          referral.value = previous;
          referralLabel.hidden = !capabilities.referrals.length; referral.disabled = !capabilities.referrals.length;
          updateReferralOther();
          updateActions();
        },
        onError(message, details) { if (current === generation && dialog.open) providerError(message, details); },
        onSuccess() {
          if (current !== generation || !dialog.open) return;
          sending = false; steps.forEach((item) => { item.hidden = true; });
          intros.forEach((item) => item.classList.remove('is-active'));
          success.hidden = false; successActions.hidden = false; actions.hidden = true; stepLabel.hidden = true;
          setError(''); retry.hidden = true;
          dialog.querySelector('[data-booking-success-email]').textContent = '';
          dialog.querySelector('[data-booking-close]').focus();
        }
      });
      updateActions();
    }
    dialog.addEventListener('booking:open', (event) => {
      trigger = event.detail?.trigger;
      const key = trigger?.closest('[data-venue-booking-key]')?.dataset.venueBookingKey;
      context = contexts.find((item) => item.key === key);
      form.reset(); sending = false; locked = false;
      success.hidden = true; successActions.hidden = true; actions.hidden = false; stepLabel.hidden = false;
      dialog.querySelectorAll('[data-booking-context]').forEach((item) => { item.textContent = context?.label || 'Venue booking'; });
      showStep(1);
      if (!context) { ++generation; adapter?.destroy(); adapter = null; loading.hidden = true; locked = true; providerError('Please close this form and select a venue booking button.', { uncertain: true }); return; }
      loadProvider();
    });
    dialog.addEventListener('close', () => { ++generation; adapter?.destroy(); adapter = null; trigger?.focus(); });
    dialog.addEventListener('click', (event) => {
      if (event.target.closest('[data-booking-close]') || event.target === dialog) dialog.close();
      const edit = event.target.closest('[data-booking-edit]');
      if (edit && !sending && !locked) { setError(''); showStep(Number(edit.dataset.bookingEdit)); }
    });
    form.addEventListener('submit', (event) => event.preventDefault());
    form.addEventListener('change', updateReferralOther);
    next.addEventListener('click', () => {
      if (sending || locked) return;
      const invalid = Array.from(steps[step - 1].querySelectorAll('input, select, textarea')).find((control) => !control.disabled && !control.checkValidity());
      if (invalid) { invalid.reportValidity(); return; }
      setError('');
      if (step < 5) { showStep(step + 1); return; }
      if (!adapter?.ready) { providerError('The venue form is not ready. Please retry loading it.', { retryable: true }); return; }
      if (adapter.submitting) return;
      sending = true; updateActions(); adapter.submit(values());
      if (!adapter.submitting) { sending = false; updateActions(); }
    });
    back.addEventListener('click', () => { setError(''); showStep(step - 1); });
    retry.addEventListener('click', () => { if (!sending && !locked) loadProvider(); });
  }
  document.querySelectorAll('[data-venue-booking-dialog]').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-venue-booking-dialog]').forEach(setup));
})();
